import { render, staticRenderFns } from "./UploadDatasetTs.vue?vue&type=template&id=00a4f4e6&scoped=true"
import script from "./UploadDatasetTs.vue?vue&type=script&lang=js"
export * from "./UploadDatasetTs.vue?vue&type=script&lang=js"
import style0 from "./UploadDatasetTs.vue?vue&type=style&index=0&id=00a4f4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4f4e6",
  null
  
)

export default component.exports